import React from 'react'
import styles from './styles.css'

export default function Loading({color = '#0165ff'}) {
  return (
    <div className={styles.container}>
      <div className={styles.item} style={{borderColor: color}} />
    </div>
  )
}
